import GetPagedWorkItemListRequestModelBase from '../_generated/modelBases/get-paged-work-item-list-request-model-base';

export default class GetPagedWorkItemListRequestModel extends GetPagedWorkItemListRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
